module.exports = __webpack_public_path__ + "img/DocView.2250ad76.png";